import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, TextField, MenuItem } from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import { getObjByName } from '../../../common/utils';
import instance from '../../../request/http';
import ExpandMore from '@material-ui/icons/ExpandMore';

const Root = styled(Box)({
    width: '405px',
    height: '100%',
    padding: '26px',
    '& .title': {
        color: '#9B9B9B',
        fontSize: '14px',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#D8D8D8',
        margin: '16px 0',
    },
    '& .typeList': {
        color: '#005F9B',
        padding: '15px 0',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        borderBottom: '1px solid #005F9B',
    },
    '& .typeList:hover': {
        color: '#009CEE',
    },
    '& .back': {
        color: '#005F9B',
        padding: '15px 0',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .back:hover': {
        color: '#009CEE',
    },
    '& .expandIconR': {
        transform: "rotate(-90deg)",
    },
    '& .expandIconL': {
        transform: "rotate(90deg)",
    },
    '& .sliderWapper': {
        margin: '25px 0',
        '& .slider': {
            margin: '0 18px',
        },
    },
    '& .textField': {
        width: '100%',
        margin: '10px 0',
    },
    '& .dateWapper': {
        '& .date': {
            '& .dateField': {
                width: '91%',
            },
            '& .title2': {
                fontWeight: 'bold',
            },
        },
    },
    '& .footer': {
        width: '353px',
        position: 'absolute',
        bottom: '25px',
        '& .btn': {
            width: '100%',
            marginTop: '18px',
        },
    },
})
const MAIN = "main";
const INDIVIDUAL = "individual";
const GROUP = "group";
class SideList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            state: MAIN,
            office: "",
            department_id: "",
            team_id: "",
            member_id: "",
            officeData: [],
            departmentsData: [],
            teamsData: [],
            membersData: [],
            totalDOTData: [],
            start_date: this.getNowDate(),
            end_date: this.getNowDate(),
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    render() {
        const {
            state,
            office,
            department_id,
            team_id,
            member_id,
            officeData,
            departmentsData,
            teamsData,
            membersData,
            start_date,
            end_date,
        } = this.state;
        const filtersInfo = () => {
            if (state === MAIN) {
                return <div>
                    <div className="typeList h" onClick={e => this.handleClick(e, INDIVIDUAL)}>
                        <div className="f">Individual Timesheet</div>
                        <ExpandMore className="expandIconR" />
                    </div>
                    <div className="typeList h" onClick={e => this.handleClick(e, GROUP)}>
                        <div className="f">Group Statistics</div>
                        <ExpandMore className="expandIconR" />
                    </div>
                </div>
            } else if (state === INDIVIDUAL) {
                return <div>
                    <div className="back h" onClick={e => this.handleClick(e, MAIN)}>
                        <ExpandMore className="expandIconL" />
                        <div>back</div>
                    </div>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Choose Office"
                        className="textField"
                        value={office}
                        onChange={e => this.handleSelect(e, 'office')}
                        margin="dense"
                        variant="outlined"
                    >
                        {officeData.map(option => (
                            <MenuItem key={option.id} value={option.office}>
                                {option.office}
                            </MenuItem>
                        ))}
                    </TextField>
                    {deptChoose()}
                    {teamChoose()}
                    {memberChoose()}
                </div>
            } else if (state === GROUP) {
                return <div>
                    <div className="back h" onClick={e => this.handleClick(e, MAIN)}>
                        <ExpandMore className="expandIconL" />
                        <div>back</div>
                    </div>
                    <div className="dateWapper h h-b">
                        <div className="date">
                            <div className="title2">From</div>
                            <TextField
                                id="start_date"
                                type="date"
                                variant="outlined"
                                className="dateField"
                                value={start_date}
                                onChange={e => this.handleChange(e, 'start_date')}
                                margin="dense"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                        <div className="date">
                            <div className="title2">To</div>
                            <TextField
                                id="end_date"
                                type="date"
                                variant="outlined"
                                className="dateField"
                                margin="dense"
                                value={end_date}
                                onChange={e => this.handleChange(e, 'end_date')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                    </div>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Choose Office"
                        className="textField"
                        value={office}
                        onChange={e => this.handleSelect(e, 'office')}
                        margin="dense"
                        variant="outlined"
                    >
                        {officeData.map(option => (
                            <MenuItem key={option.id} value={option.office}>
                                {option.office}
                            </MenuItem>
                        ))}
                    </TextField>
                    {deptChoose()}
                    {teamChoose()}
                </div>
            }
        }
        const deptChoose = () => {
            if (office) {
                return <TextField
                    id="outlined-select-currency"
                    select
                    label="Choose Department"
                    className="textField"
                    value={department_id}
                    onChange={e => this.handleSelect(e, 'department_id')}
                    margin="dense"
                    variant="outlined"
                >
                    {departmentsData.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        const teamChoose = () => {
            if (department_id) {
                return <TextField
                    id="outlined-select-currency"
                    select
                    label="Choose Team"
                    className="textField"
                    value={team_id}
                    onChange={e => this.handleSelect(e, 'team_id')}
                    margin="dense"
                    variant="outlined"
                >
                    {teamsData.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        const memberChoose = () => {
            if (team_id) {
                return <TextField
                    id="department_id"
                    select
                    label="Member"
                    className="textField"
                    value={member_id}
                    onChange={e => this.handleSelect(e, "member_id")}
                    margin="dense"
                    variant="outlined"
                >
                    {(membersData || []).map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.first_name} {option.last_name} / {option.email} / {option.phone}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        return (
            <Root>
                <div className="filters h h-r">
                    <div>Filters</div>
                </div>
                <div className="line"></div>
                {filtersInfo()}
                <div className="footer v c">
                    <div className="line"></div>
                    <Button className="btn" variant="contained" onClick={this.handleClear}>CLEAR</Button>
                    <Button className="btn" variant="contained" color="primary" onClick={this.handleApply}>APPLY FILTERS</Button>
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.getDepartments(() => {
            this.initData();
        });
    }
    initData() {
        const { data } = this.props;
        console.log(data);
        if (data) {
            const state = data.state;
            const start_date = this.getNowDate(data.start_date);
            const end_date = this.getNowDate(data.end_date);
            const office = data.office;
            const department_id = data.department_id;
            const team_id = data.team_id;
            const member_id = data.member_id;
            if (state === INDIVIDUAL) {
                this.setNextData("office", office, () => {
                    this.setNextData("department_id", department_id, () => {
                        this.setState({
                            team_id,
                        }, () => {
                            this.setNextData("team_id", team_id, () => {
                                this.setState(() => ({
                                    member_id
                                }));
                            })
                        });
                    })
                })
                this.setState(() => ({
                    state,
                    office,
                    department_id,
                }));
            } else if (state === GROUP) {
                this.setNextData("office", office, () => {
                    this.setNextData("department_id", department_id, () => {
                        this.setState(() => ({
                            team_id
                        }));
                    })
                })
                this.setState(() => ({
                    state,
                    start_date,
                    end_date,
                    office,
                    department_id,
                }));
            }else if(state === MAIN){
                this.setState(() => ({
                    state,
                }));
            }
        }
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleClick(e, name) {
        this.setState(() => ({
            state: name
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        const { totalDOTData, teamsData } = this.state;
        if (name === "office") {
            //1.清理department、team数据 2.根据office的name在整个data中查找dept的obj
            this.clearSelectData("department_id");
            const departmentsData = this.filterObjArr(totalDOTData, name, value);
            this.setState(() => ({
                departmentsData
            }));
        } else if (name === "department_id") {
            //1.清理team数据 2.根据dept的name在整个data中查找dept的obj 3.根据deptid获取team
            this.clearSelectData("team_id");
            this.getTeams(value, () => { });
        } else if (name === "team_id") {
            //1.清理member数据 2.根据选择的team筛选出member数据
            this.clearSelectData("member_id");
            const teamObj = getObjByName(teamsData, "id", value);
            this.setState(() => ({
                membersData: teamObj.members,
                team_id: teamObj.id
            }));
        }
        this.setState(() => ({
            [name]: value
        }))
    }
    handleClear() {
        this.clearData();
    }
    handleApply() {
        const {
            state,
            office,
            department_id,
            team_id,
            member_id,
            start_date,
            end_date,
        } = this.state;
        let obj = {};
        if (state === INDIVIDUAL) {
            obj = {
                state,
                office,
                department_id,
                team_id,
                member_id,
            };
        } else if (state === GROUP) {
            obj = {
                state,
                start_date: (Date.parse(new Date(start_date)) / 1000) + "",
                end_date: (Date.parse(new Date(end_date)) / 1000) + "",
                office,
                department_id,
                team_id,
            };
        } else if (state === MAIN) {
            obj = {
                state
            };
        }
        // console.log(obj)
        this.props.handleApply(obj);
    }
    //对象数组去重
    deduplicationObjArr(objArr, key) {
        const newMap = new Map();
        const deduplicationObjArr = objArr.filter((obj) => !newMap.has(obj[key]) && newMap.set(obj[key], 1));
        const arr = this.filterArr(deduplicationObjArr)
        return arr
    }
    filterArr(data) {
        let arr = []
        for (const obj of data) {
            if (obj.office !== null && obj.office !== "") {
                arr.push(obj)
            }
        }
        return arr;
    }
    //对象数组过滤出相同的obj
    filterObjArr(objArr, key, name) {
        let newObjArr = [];
        for (const obj of objArr) {
            if (obj[key] === name) {
                newObjArr.push(obj);
            }
        }
        return newObjArr
    }
    setNextData(name, value, callback = null) {
        const { totalDOTData, teamsData } = this.state;
        if (name === "office") {
            //1.清理department、team数据 2.根据office的name在整个data中查找dept的obj
            this.clearSelectData("department_id");
            const departmentsData = this.filterObjArr(totalDOTData, name, value);
            this.setState({
                departmentsData
            }, () => {
                callback();
            });
        } else if (name === "department_id") {
            //1.清理team数据 2.根据dept的name在整个data中查找dept的obj 3.根据deptid获取team
            this.clearSelectData("team_id");
            if (value) {
                this.getTeams(value, () => {
                    callback();
                });
            }
        } else if (name === "team_id") {
            //1.清理member数据 2.根据选择的team筛选出member数据
            this.clearSelectData("member_id");
            if (value) {
                const teamObj = getObjByName(teamsData, "id", value);
                this.setState({
                    membersData: teamObj.members,
                    team_id: teamObj.id
                }, () => {
                    callback();
                });
            }
        }
    }
    clearSelectData(name) {
        if (name === "team_id") {
            this.setState(() => ({
                team_id: "",
                teamsData: [],
                member_id: "",
                membersData: []
            }))
        } else if (name === "department_id") {
            this.setState(() => ({
                department_id: "",
                team_id: "",
                teamsData: [],
                member_id: "",
                membersData: []
            }))
        } else if (name === "member_id") {
            this.setState(() => ({
                member_id: "",
                membersData: []
            }))
        }
    }
    clearData() {
        this.setState(() => ({
            state: MAIN,
            office: "",
            department_id: "",
            team_id: "",
            member_id: "",
            departmentsData: [],
            teamsData: [],
            membersData: [],
            start_date: this.getNowDate(),
            end_date: this.getNowDate(),
        }))
    }
    getNowDate(dateStr = null) {
        let date = null;
        if (dateStr) {
            date = new Date(dateStr * 1000);
        } else {
            date = new Date();
        }
        let dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split("T")[0];
        return dateString;
    }
    //-------------request------------------------
    getDepartments(callback = null) {
        instance.get(BASE_URL + 'admin/departments').then((res) => {
            let totalDOTData = res.data.data;
            let officeData = this.deduplicationObjArr(totalDOTData, "office")
            //过滤出重复office
            this.setState(() => ({
                totalDOTData,
                officeData
            }))
            console.log("totalDOTData", totalDOTData)
            if (callback) callback()
        })
    }
    getTeams(dept_id, callback = null) {
        const params = {
            dept_id
        }
        instance.get(BASE_URL + 'admin/teams', { params }).then((res) => {
            const teamsData = res.data.data;
            this.setState({
                teamsData
            }, () => {
                if (callback) callback();
            });
        })
    }
}

export default SideList;